import { keepPreviousData, useQuery } from '@tanstack/react-query'
import type { ChatConversationItem, ChatMessageItem } from '@ayub/shared'
import { fetchChatMessages, fetchConversations, fetchUnreadCount } from './api'

/**
 * Suhbatlar ro'yxati — Chat bo'limi ochiq bo'lganda ~3s da yangilanadi (blogerdan yangi xabar
 * tez ko'rinsin). Naqsh: `broadcast/hooks.ts`dagi funksiya-shaklidagi `refetchInterval`.
 */
export function useConversations(enabled: boolean) {
  const query = useQuery<ChatConversationItem[], Error>({
    queryKey: ['chat', 'conversations'],
    queryFn: fetchConversations,
    enabled,
    refetchInterval: enabled ? 3000 : false,
    placeholderData: keepPreviousData,
  })
  return {
    conversations: query.data ?? [],
    isLoading: query.isLoading,
    error: query.isError ? query.error : null,
  }
}

/** Bitta suhbat tarixi — suhbat ochiq bo'lganda ~2s da yangilanadi (jonli chat). */
export function useChatMessages(bloggerId: number | null) {
  const query = useQuery<ChatMessageItem[], Error>({
    queryKey: ['chat', 'messages', bloggerId],
    queryFn: () => fetchChatMessages(bloggerId as number),
    enabled: bloggerId !== null,
    refetchInterval: bloggerId !== null ? 2000 : false,
    placeholderData: keepPreviousData,
  })
  return {
    messages: query.data ?? [],
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.isError ? query.error : null,
    refetch: query.refetch,
  }
}

/**
 * Menyudagi o'qilmagan belgisi — doim (fonda) 15s da yangilanadi. Yengil so'rov (bitta son).
 */
export function useChatUnreadCount() {
  const query = useQuery<number, Error>({
    queryKey: ['chat', 'unread-count'],
    queryFn: async () => (await fetchUnreadCount()).unread,
    refetchInterval: 15000,
    refetchOnWindowFocus: true,
    placeholderData: keepPreviousData,
  })
  return query.data ?? 0
}
